<template>
  <a-modal title="时段修正"
           :width="800"
           :open="modal"
           :confirloading="loading"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">

    <div v-for="(v, i) in conf" :key="i" class="dvd">
      <a-space>
        <span>开始时间</span>
        <a-time-picker size="small" v-model:value="v.start"/>

        <span>结束时间</span>
        <a-time-picker size="small" v-model:value="v.end"/>

        <span>卡片ID</span>
        <a-input-number size="small" v-model:value="v.id" min="1"/>

        <span>概率</span>
        <a-input-number size="small" v-model:value="v.chance" min="0"/>

        <a-button danger size="small" @click="delCk(i)">-</a-button>
      </a-space>
    </div>

    <div>
      <a-button size="small" type="primary" @click="addCk">+</a-button>
    </div>

  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message, Modal} from 'ant-design-vue'
import dayjs from 'dayjs'

const modal = ref(false)
const loading = ref(false)

const conf = ref({})

function openCk() {
  query()
  modal.value = true
}

function query() {
  axios.get('/config/chance_fix').then((res) => {
    if (res.code === 1) {
      let tmp = res.data
      for (let i of tmp) {
        i.start = dayjs(i.start, 'HH:mm:ss')
        i.end = dayjs(i.end, 'HH:mm:ss')
      }
      conf.value = tmp
    }
  })
}

function addCk() {
  conf.value.push({
    start: "",
    end: "",
    id: 0,
    chance: 0,
  })
}

function delCk(idx) {
  Modal.confirm({
    content: '确定删除吗',
    okText: '确定',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      conf.value.splice(idx, 1)
    },
  })
}

function okCk() {
  loading.value = true
  let tmp = []
  for (const i of conf.value) {
    tmp.push({
      start: i.start.format('HH:mm:ss'),
      end: i.end.format('HH:mm:ss'),
      id: i.id,
      chance: i.chance,
    })
  }
  axios.post('/config/chance_fix', {
    v: tmp,
    c: 1,
  }).then((res) => {
    if (res.code === 1) {
      message.success('操作成功')
    }
    modal.value = false
    loading.value = false
  })
}

function cancelCk() {
  modal.value = false
  loading.value = false
}

defineExpose({openCk})
</script>

<style scoped>
.dvd {
  margin-bottom: 5px;
}

.dvd:last-child {
  margin-bottom: 0;
}
</style>
